import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 14, viewBox: "0 0 7 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.24988 12.94L1.35988 8.05C0.782383 7.4725 0.782383 6.5275 1.35988 5.95L6.24988 1.06", stroke: "#595E6A", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
